import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbd6e670"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "address-text" }

import { ref, PropType } from 'vue';
import type { Address } from "@/types/locality/Address";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressChoiceModal',
  props: {
  addresses: {
    type: Array as PropType<Address[]>,
    required: true
  }
},
  emits: {
  addressChosen: (address: Address | null) => true
},
  setup(__props, { emit }) {

const props = __props;





const isModalShown = ref(true);

function formatAddress(address: Address): string {
  return `${address.prefecture} ${address.city} ${address.town}`;
}

function onClickAddress(address: Address) {
  emit("addressChosen", address);
}

function onCancel() {
  emit("addressChosen", null);
}

return (_ctx: any,_cache: any) => {
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    modelValue: isModalShown.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isModalShown).value = $event)),
    title: "該当する住所を選択してください",
    size: "lg",
    "content-class": "address-modal",
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    "hide-footer": "",
    centered: "",
    onHide: onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.addresses, (address) => {
          return (_openBlock(), _createElementBlock("div", {
            key: address.id,
            class: "address-item",
            onClick: ($event: any) => (onClickAddress(address))
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(formatAddress(address)), 1)
          ], 8, _hoisted_2))
        }), 128))
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modelValue"]))
}
}

})